import { render, staticRenderFns } from "./IconPlayStrikeThrough.vue?vue&type=template&id=4e5a5136"
import script from "./IconPlayStrikeThrough.vue?vue&type=script&lang=js"
export * from "./IconPlayStrikeThrough.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports